module.exports = __webpack_public_path__ + "static/media/THE NEW PLAYBOOK - EBOOK.be215aae.pdf";